import './EmptyList.scss'

import React from 'react'
import { Link } from 'react-router-dom'

import { ContactUs } from 'hb4e-ui-core-ui'

const EmptyList = () => {
  return (
    <div className="empty-list">
      <div className="empty-list__content">
        <p className="empty-list__title">This list does not contain any items.</p>
        <p className="empty-list__body">
          <Link className="empty-list__link" to="/search">
            Search
          </Link>{' '}
          our catalog to find course materials.
        </p>
      </div>

      <div className="empty-list__contact-us">
        <ContactUs>
          If you’d like assistance, contact us. Customer Service is available 24 hours a day, 7 days a week.
        </ContactUs>
      </div>
    </div>
  )
}

export default EmptyList
